<app-chip-filter
  [filterList]="filters"
  [selectedFilter]="selectedFilter"
  [filter]="filter"
  [habilitarcheck]="habilitarcheck"
  (output)="outputData($event)"
></app-chip-filter>
